interface CustomTooltipProps {
  x: number;
  y: number;
  trueAge: number;
  gutAge: number;
  isVisible: boolean;
}

import { Typography } from '@repo/ui';
import { stringifyDaysOld } from 'helpers';

export default function CustomTooltip({
  x,
  y,
  trueAge,
  gutAge,
  isVisible,
}: CustomTooltipProps) {
  if (!isVisible) return <></>;
  return (
    <div
      style={{
        position: 'absolute',
        top: y - 55,
        left: x - 50,
        backgroundColor: '#fff',
        border: '1px solid var(--warm-grey-400)',
        color: 'var(--warm-grey-900)',
        padding: '5px 10px',
        borderRadius: '4px',
        fontSize: '12px',
        pointerEvents: 'none',
        zIndex: 1000,
      }}
    >
      <div className='flex flex-column'>
        <div className='flex align-items-center gap-1'>
          <Typography variant='label'>Real age:</Typography>
          <Typography variant='label' weight='bold'>
            {stringifyDaysOld(trueAge, false)}
          </Typography>
        </div>
        <div className='flex align-items-center gap-1'>
          <Typography variant='label'>Gut age:</Typography>
          <Typography variant='label' weight='bold'>
            {stringifyDaysOld(gutAge, false)}
          </Typography>
        </div>
      </div>
    </div>
  );
}
